<script lang="ts">
  import WorkOrderPropertyTag from "../../../../../../../../../_shared/_modules/work-order-property-tag"
  import type { PropertyObjectTagPresentation } from "../../../../../../../../../_shared/_logic/object-tags"
  import { buildWorkOrderTablePropertyTag } from "../../_logic/work-order-table-tags"

  let {
    tag = null,
    tooltipContent = null,
    property = null,
    propertyUnitId = null,
    addressLabel = "",
    unitLabel = "",
    disabled = false,
  }: {
    tag?: PropertyObjectTagPresentation | null
    tooltipContent?: string | null
    property?: Property | null
    propertyUnitId?: string | null
    addressLabel?: string | null
    unitLabel?: string | null
    disabled?: boolean
  } = $props()

  const visibleUnitLabel = $derived.by(() => {
    const text = String(unitLabel ?? "").trim()

    if (!text) return unitLabel

    return text.toLocaleLowerCase("de-DE").startsWith("zuordnung:") ? null : unitLabel
  })
  const presentation = $derived(
    tag
      ? { tag, tooltipContent: tooltipContent ?? "" }
      : buildWorkOrderTablePropertyTag({
          property,
          propertyUnitId,
          addressLabel,
          unitLabel: visibleUnitLabel,
        }),
  )
</script>

<WorkOrderPropertyTag
  tag={presentation.tag}
  tooltipContent={presentation.tooltipContent}
  {disabled}
/>
